export default __webpack_public_path__ + "static/media/undraw_Browsing_online_re_umsa.fd851472.png";